import { UserPrefsStoreModule, UserPrefsAppConnector, pageSizesMetaReducer } from '@aston/user-prefs';
import { FilesManagerStoreModule, FilesManagerAppConnector } from '@aston/files-manager';
import { Store, StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';

import { UserService } from '../user-module/services';

import { DunningActionDetailStoreModule } from './dunning-action-detail-store/dunning-action-detail-store.module';
import { AppStoreModule } from './app-store/app-store.module';
import * as AppStoreSelectors from './app-store/selectors';
import { logoutMetaReducer } from './app-store/reducer';
import * as AppStoreActions from './app-store/actions';


export function stateSetter(reducer) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return function (state: any, action: any) {
		const NGRX_STATE = '___NGRX_STATE___';
		const newState = reducer(state, action);
		if (action.type !== '@ngrx/store/init') {
			return window[NGRX_STATE] = newState;
		} else {
			if (window[NGRX_STATE]) {
				return window[NGRX_STATE];
			}
			return newState;
		}
	};
}

function _debugMetaReducer(reducer: CallableFunction) {
	return function (previs: any, action: any) {
		const state = reducer(previs, action)

		// if (
		// 	previs?.dunningActionDetail?.dunningAction?.entity
		//  && !state?.dunningActionDetail?.dunningAction?.entity
		// ) {
		// 	console.log(`action %o cleared %o`, action, 'dunningActionDetail.dunningAction.entity')
		// }

		return state
	}
}

// The metareducers option allow to reset the whole internal state on logout
// see https://ngrx.io/guide/store/metareducers
// export const MetareducedStoreModule = StoreModule.forRoot({}, { metaReducers: [logout, throwOnUndefined] });
export const MetareducedStoreModule = StoreModule.forRoot({}, {
	metaReducers: [stateSetter, logoutMetaReducer, pageSizesMetaReducer],
	runtimeChecks: {
		// because we are savages
		strictStateImmutability: false,
		strictActionImmutability: false,
		strictStateSerializability: false,
		strictActionSerializability: false,
	},
});

export const userPrefsAppConnector = (store: Store, us: UserService) => ({
	currentPreferences: store.select(AppStoreSelectors.selectCurrentUserPrefs),
	updatePreferences: prefs => us.savePreferences(prefs),
	updateFilters: filters => us.saveUserFilters(filters)
})

export const filesManagerAppConnector = (store: Store) => ({
	// The FileManager should try its best to to a proper download. #35918
	download: document => store.dispatch(AppStoreActions.DownloadDocument({ document })),
	preview: document => store.dispatch(AppStoreActions.PreviewDocument({ document })),
})

@NgModule({
	declarations: [],
	imports: [
		AppStoreModule,
		CommonModule,
		DunningActionDetailStoreModule,
		EffectsModule.forRoot([]),
		FilesManagerStoreModule.forRoot({
			app: {
				provide: FilesManagerAppConnector,
				useFactory: filesManagerAppConnector,
				deps: [Store]
			}
		}),
		MetareducedStoreModule,
		UserPrefsStoreModule.forRoot({
			app: {
				provide: UserPrefsAppConnector,
				useFactory: userPrefsAppConnector,
				deps: [Store, UserService]
			}
		}),
	]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class RootStoreModule { }
